import React, { useEffect, useRef, useState } from "react";
import "../Pages/CSS/Traitement.css";
import * as XLSX from "xlsx";
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Progress,
  Form,
  Input,
  InputNumber,
  Menu,
  Modal,
  Popconfirm,
  Radio,
  Row,
  Select,
  Space,
  Table,
  Tag,
  message,
  Spin,
  Tooltip,
} from "antd";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CalculatorOutlined,
  CheckSquareOutlined,
  CloseCircleOutlined,
  CloseSquareOutlined,
  CloudUploadOutlined,
  DeleteOutlined,
  EditOutlined,
  EllipsisOutlined,
  ExportOutlined,
  SearchOutlined,
  EyeOutlined,
  MoreOutlined,
  PlusCircleOutlined,
  PrinterOutlined,
  SyncOutlined,
  UploadOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { ExerciceDocService } from "../Services/ExerciceDocService";
import { TraitementService } from "../Services/TraitementService";
import { SpecialitesService } from "../Services/SpecialitesService";
import { ListFournisService } from "../Services/ListFournisService";
import { AdherentsService } from "../Services/AdherentsService";
import { FactureService } from "../Services/FactureService";
import moment from "moment";
import dayjs from "dayjs";
import ExportFacture from "./ExportFacture";
import { useNavigate } from "react-router-dom";
import PreviewModal from "./PreviewModal";
import "moment/locale/fr"; // Importation de la localisation française
import Draggable from "react-draggable";

const DraggableModal = ({ children, ...props }) => {
  const [disabled, setDisabled] = useState(true);
  const draggleRef = useRef(null);

  return (
    <Modal
      {...props}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={draggleRef.current ? draggleRef.current : undefined}
          handle=".ant-modal-title"
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
      title={
        <div
          className="ant-modal-title"
          style={{ width: "100%", cursor: "move" }}
          onMouseOver={() => setDisabled(false)}
          onMouseOut={() => setDisabled(true)}
        >
          {props.title}
        </div>
      }
    >
      {children}
    </Modal>
  );
};

moment.locale("fr");

const { confirm } = Modal;
const { Option } = Select;
const TraiteFournSoins = () => {
  const navigate = useNavigate();
  const specialistesService = new SpecialitesService();


  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedYearExercises, setSelectedYearExercises] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [loading, setLoading] = useState([]);
  const [loadingCompta, setLoadingCompta] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [isModalOpenCompta, setIsModalOpenCompta] = useState(false);
  const [selectedMonthCompta, setSelectedMonthCompta] = useState(dayjs());
  const [selectedOption, setSelectedOption] = useState("R");
  const [selectedType, setSelectedType] = useState("Toutes");
  const [specialitesData, setSpecialitesData] = useState(null);
  const [isPrescripteurSelectEnabled, setIsPrescripteurSelectEnabled] =
    useState(false);
  const [prescripteursData, setPrescripteursData] = useState([]);
  const [montantNetAffiche, setMontantNetAffiche] = useState(0);
  const [loadingSpecialites, setLoadingSpecialites] = useState(false);
  const [loadingValid, setLoadingValid] = useState(false);
  const [loadingFournisseur, setLoadingFournisseurs] = useState(false);
  const [searchFilters, setSearchFilters] = useState({});
  const [globalSearchValue, setGlobalSearchValue] = useState("");
  const [isFileModalVisible, setIsFileModalVisible] = useState(false);
  const [selectedNumenreg, setSelectedNumenreg] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [selectedFact, setSelectedFact] = useState(null);
  const [checkedValue, setCheckedValue] = useState("Normale");
  const [isModalVisible1, setIsModalVisible1] = useState(false);
  const [isModalRejet, setIsModalRejet] = useState(false);
  const [isModalVentil, setIsModalventil] = useState(false);
  const [isPreviewModalVisible, setIsPreviewModalVisible] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const [montantPrepaye, setMontantPrepaye] = useState(0);
  const [confirmedMontantPrepaye, setConfirmedMontantPrepaye] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filterColumns, setFilterColumns] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [displayedInvoiceData, setDisplayedInvoiceData] = useState([]);
  const [refreshTable, setRefreshTable] = useState(false);
  const [years, setYears] = useState([]);
  const [paramData, setParamData] = useState([]);
  const [adherentsData, setAdherentsData] = useState([]);
  const [selecteAdherent, setSelectedAdherent] = useState("AA");
  const [yearsExercises, setYearsExercises] = useState([]);
  const [ristourneValue, setRistourneValue] = useState(0);
  const [remiseValue, setRemiseValue] = useState(0);
  const [freelValue, setFreelValue] = useState(0);
  const [agentValue, setAgentValue] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [comptaPreviewData, setComptaPreviewData] = useState([]);
  const [isAnnulationModalOpen, setIsAnnulationModalOpen] = useState(false);
  const [annulationPreviewData, setAnnulationPreviewData] = useState([]);
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [formValues, setFormValues] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [isPrintModalVisible, setIsPrintModalVisible] = useState(false);

  const traitementsoinsService = new TraitementService();
  const exerciceDocService = new ExerciceDocService();
  const fournisseurService = new ListFournisService();
  const adherentsServices = new AdherentsService();
  const factureService = new FactureService();

  const [progress, setProgress] = useState(0);
  const [isProgressModalVisible, setIsProgressModalVisible] = useState(false);
  const progressIntervalRef = useRef(null);

  const param3 = async () => {
    try {
      const getParam = await traitementsoinsService.getParamComptable();
      setParamData(getParam);
      const monthFromParamData = dayjs(getParam.datedeb).format("MM");
      const yearFromParamData = dayjs(getParam.datedeb).format("YYYY");
      setSelectedYear(yearFromParamData)
      // setSelectedMonthImp(monthFromParamData);
      setSelectedMonth(monthFromParamData)
      // setSelectedYearExercises(yearFromParamData)
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  useEffect(() => {
    param3()
  }, [])

  const fetchData = async () => {
    try {
      const yearsData = await exerciceDocService.getFactureExercicesDoc();
      setYears([...yearsData].sort((a, b) => b - a));
      setYearsExercises([...yearsData].sort((a, b) => b - a))
      await fetchDataByOption(selectedOption);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [selectedYear, selectedMonth, selectedOption, selectedType, refreshTable]);

  const formatDateToMonthYear = (dateString) => {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "long" };
    return date.toLocaleDateString("fr-FR", options).toUpperCase();
  };

  const startProgressWithApi = async (apiPromise) => {
    setProgress(1);
    setIsProgressModalVisible(true);

    // Fait progresser la barre jusqu'à 90% tant que l'API n'a pas répondu
    progressIntervalRef.current = setInterval(() => {
      setProgress((prev) => (prev < 90 ? prev + 2 : prev));
    }, 200);

    try {
      await apiPromise; // Attend la fin de l'appel API
      setProgress(100);
      setTimeout(() => {
        setIsProgressModalVisible(false);
        setProgress(0);
      }, 500);
    } finally {
      clearInterval(progressIntervalRef.current);
    }
  };

  const handleDeleteline = async (numenreg) => {
    try {
      confirm({
        title: `Êtes-vous sûr de vouloir supprimer la facture N° ${numenreg} ?`,
        okText: "Oui",
        cancelText: "Non",
        onOk: async () => {
          try {
            await traitementsoinsService.deleteFacture(numenreg);
            const updatedData = filteredData.filter(
              (item) => item.numenreg !== numenreg
            );
            setFilteredData(updatedData);
            fetchDataByOption(selectedOption);
          } catch (error) {
            console.error("Erreur lors de la suppression du document :", error);
          }
        },
        onCancel() {
          // Annulation
        },
      });
    } catch (error) {
      console.error(
        "Erreur lors de la confirmation de la suppression :",
        error
      );
    }
  };
  const fetchExercises = async () => {
    try {
      const yearsData = await exerciceDocService.getComptaExercices();
      setYearsExercises(yearsData);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };



  const fetchAdherents = async () => {
    try {
      const adherents = await adherentsServices.getAllAdherents();
      setAdherentsData(adherents);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  useEffect(() => {
    fetchAdherents();
    // fetchExercises();
  }, []);

  // Ajoutez ce menu juste avant le composant TraiteFournSoins
  // const selectionMenu = (
  //   <Menu>
  //     <Menu.Item
  //       key="selectAll"
  //       onClick={() => {
  //         const allKeys = filteredData.map((item) => item.numenreg);
  //         setSelectedRowKeys(allKeys);
  //       }}
  //     >
  //       Tout sélectionner
  //     </Menu.Item>
  //     <Menu.Item
  //       key="deselectAll"
  //       onClick={() => {
  //         setSelectedRowKeys([]);
  //       }}
  //     >
  //       Tout désélectionner
  //     </Menu.Item>
  //   </Menu>
  // );


  const fetchDataByOption = async (option) => {
    if (!selectedYear) {
      console.warn("selectedYear n'est pas défini, arrêt de fetchDataByOption.");
      return;
    }

    setLoading(true);
    try {
      const allRows = await traitementsoinsService.getAllFactureSoins(selectedYear);
      const sourceData = Array.isArray(allRows) ? allRows : [];

      const getDateFieldByEtat = (item, etatToUse) => {
        switch (etatToUse) {
          case "T":
          case "C":
          case "P":
          case "S":
          case "J":
            return item.datetrait;
          case "R":
            return item.datesaisie;
          default:
            return (
              item.daterecep ||
              item.datesaisie ||
              item.datefact ||
              item.date_process ||
              item.datetrait ||
              item.datecompta ||
              item.datereglmt
            );
        }
      };

      const getYearDateFieldByEtat = (item, etatToUse) => {
        if (etatToUse === "A") {
          return item.datesaisie;
        }

        if (["T", "C", "P"].includes(etatToUse)) {
          return item.datetrait;
        }

        return getDateFieldByEtat(item, etatToUse);
      };

      const monthFilteredStates = ["T", "C", "P"];

      const data = sourceData.filter((item) => {
        const itemEtat = item?.etat;
        const etatFilterValue = option;

        const matchesEtat = etatFilterValue === "A" ? true : itemEtat === etatFilterValue;
        if (!matchesEtat) return false;

        const dateField = getDateFieldByEtat(item, etatFilterValue === "A" ? itemEtat : etatFilterValue);
        const yearDateField = getYearDateFieldByEtat(item, etatFilterValue === "A" ? itemEtat : etatFilterValue);
        const parsedDate = dateField ? dayjs(dateField) : null;
        const parsedYearDate = yearDateField ? dayjs(yearDateField) : null;

        // Quand l'état = "A", l'API renvoie déjà le bon exercice: on n'élimine aucune ligne côté client.
        const matchesYear = etatFilterValue === "A"
          ? true
          : !parsedYearDate || !parsedYearDate.isValid()
            ? true
            : parsedYearDate.format("YYYY") === String(selectedYear);
        if (!matchesYear) return false;

        const shouldFilterByMonth = monthFilteredStates.includes(etatFilterValue);
        const matchesMonth = !shouldFilterByMonth || !selectedMonth || selectedMonth === "13" || !parsedDate || !parsedDate.isValid()
          ? true
          : parsedDate.format("MM") === selectedMonth;
        if (!matchesMonth) return false;

        const selectedNatFact = (selectedType || "Toutes").toLowerCase();
        const rowNatFact = (item?.nature_fact || "").toLowerCase();
        const matchesNatFact = selectedNatFact === "toutes" ? true : rowNatFact === selectedNatFact;

        return matchesNatFact;
      });

      setTableData(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    } finally {
      setLoading(false);
    }
  };




  // Fonction pour gérer la sélection du mois
  const handleMonthChange = (value) => {
    setSelectedMonth(value.toString().padStart(2, "0"));
  };

  useEffect(() => {
    handleSearchFourn(searchFilters, globalSearchValue);
    setFilterColumns(filterColumnsByOption(selectedOption));
  }, [tableData, selectedOption]);

  const handleSelectChange = (e) => {
    setSelectedOption(e);
    setFilterColumns(filterColumnsByOption(e));
  };

  const handleClotureMensuelle = async () => {
    confirm({
      title: "Confirmation",
      content: (
        <>
          Veuillez confirmer la clôture mensuelle du mois de
          <strong> {formatDateToMonthYear(paramData.datedeb)} </strong>
        </>
      ),
      okText: "Confirmer",
      cancelText: "Annuler",
      onOk: async () => {
        try {
          // Appeler l'API closeMensuel en premier
          await traitementsoinsService.closeMensuel();

          // Construire le payload
          const payload = {
            numparam: "param3",
            perim: "IPM",
          };

          // Appeler l'API closeOpenMensuel avec le payload
          await traitementsoinsService.closeOpenMensuel(payload);

          // Appeler param3() et attendre que paramData soit mis à jour
          const updatedParam = await traitementsoinsService.getParamComptable();
          setParamData(updatedParam);

          // Utiliser le nouveau paramData après la mise à jour
          const newDateDeb = formatDateToMonthYear(updatedParam.datedeb);

          fetchDataByOption(selectedOption);

          // Afficher un message de succès avec le mois mis à jour
          message.success(
            `Clôture mensuelle confirmée. Nouveau mois : ${newDateDeb}`
          );
        } catch (error) {
          console.error("Erreur lors de la clôture mensuelle :", error);
          message.error("Erreur lors de la clôture mensuelle");
        }
      },
      onCancel() {
        message.info("Clôture mensuelle annulée");
      },
    });
  };


  const handleOpenModalcompta = () => {
    setIsModalOpenCompta(true);
  };

  const handleCancelcompta = () => {
    setIsModalOpenCompta(false);
  };

  const handlecomptaOk = () => {
    const selectedRows = tableData.filter((row) =>
      selectedRowKeys.includes(row.numenreg)
    );
    const payload = selectedRows
    const formattedMonthCompta = dayjs(selectedMonthCompta).startOf('month').format('YYYY-MM-DD');
    Modal.confirm({
      title: "Confirmation",
      content: "Êtes-vous sûr de vouloir confirmer le retour mensuel ?",
      okText: "Oui",
      cancelText: "Non",
      onOk: async () => {
        try {
          await traitementsoinsService.reculClôtureMensuel1(formattedMonthCompta, payload);
          param3();
          fetchDataByOption(selectedOption);
          message.success("Retour mensuel confirmé");
          setIsModalOpenCompta(false);
        } catch (error) {
          console.error("Erreur lors du retour mensuel :", error);
          message.error("Erreur lors du retour mensuel");
        }
      },
    });// Met à jour l'état global avec le mois sélectionné dans le modal

  };

  const handleMonthcomptaChange = (value) => {
    setSelectedMonthCompta(value); // Met à jour uniquement l'état local
  };



  const handleComptabiliser = async () => {
    try {
      const selectedRows = tableData.filter((row) =>
        selectedRowKeys.includes(row.numenreg)
      );

      if (selectedRows.length > 0) {
        // Prenons la première ligne sélectionnée comme référence pour le numfact et numfourn
        const { numfact, numfourn } = selectedRows[0];
        setSelectedFact({ numfact, numfourn }); // Stocker les informations dans l'état
      }

      const data = await traitementsoinsService.addPreviewCompta(selectedRows);
      setComptaPreviewData(data);
      setIsModalOpen(true);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };

  const handleAnnulationComptabilisation = async (numenreg) => {
    try {
      const data = await traitementsoinsService.getPreviewCancelCompta(
        numenreg
      );
      setAnnulationPreviewData(data);
      setIsAnnulationModalOpen(true);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données d'annulation :",
        error
      );
    }
  };

  const onchangeAdherent = (value) => {
    setSelectedAdherent(value);
  };

  /* const handleValidCompta = async () => {
    try {
      const selectedRows = tableData.filter((row) =>
        selectedRowKeys.includes(row.numenreg)
      );
      const payload = {
        comptas: comptaPreviewData,
        factures: selectedRows,
      };
      const data = await traitementsoinsService.addValidCompta(payload);
      setRefreshTable(!refreshTable);
      setIsModalOpen(false);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  }; */
  const handleValidCompta = async () => {
    if (loadingValid) return; // Empêche le double clic rapide
    setLoadingValid(true);

    try {
      // Vérification des comptes généraux vides ou null
      const hasEmptyCompteGen = comptaPreviewData.some(
        (item) => !item.comptegen || item.comptegen.trim() === ""
      );
      if (hasEmptyCompteGen) {
        Modal.error({
          title: "Erreur de validation",
          content: "Un ou plusieurs comptes généraux sont vides. Veuillez corriger avant de valider.",
        });
        setLoadingValid(false);
        return;
      }

      const selectedRows = tableData.filter((row) =>
        selectedRowKeys.includes(row.numenreg)
      );
      const payload = {
        comptas: comptaPreviewData,
        factures: selectedRows,
      };

      await traitementsoinsService.addValidCompta(payload);
      setRefreshTable(!refreshTable);
      setIsModalOpen(false);
      message.success("Validation comptable réussie !");
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
      message.error("Erreur lors de la validation comptable.");
    } finally {
      setLoadingValid(false);  // Désactive le loading du bouton
    }
  };

  const handleValidAnnulationCompta = async () => {
    try {
      // Payload pour addAnnulationCompta
      const addPayload = annulationPreviewData;

      // Payload pour putAnnulationCompta
      const putPayload = annulationPreviewData.map((item) => item.numfactipm);

      await traitementsoinsService.addAnnulationCompta(addPayload);
      await traitementsoinsService.putAnnulationCompta(putPayload);

      setRefreshTable(!refreshTable);
      setIsAnnulationModalOpen(false);
    } catch (error) {
      console.error(
        "Erreur lors de la validation de l'annulation de la comptabilisation :",
        error
      );
    }
  };

  const filterColumnsByOption = (option) => {
    switch (option) {
      case "R":
        return [...columns].filter(
          (column) =>
            ![
              "date_process",
              "datecompta",
              "datereglmt",
              "datetrait",
              "compta_by",
              "process_by",
            ].includes(column.key)
        );

      case "T":
        return [...columns].filter(
          (column) =>
            !["datecompta", "compta_by",  /* "datetrait", */  "datereglmt"].includes(
              column.key
            )
        );
      case "C":
        return [...columns].filter(
          (column) => !["datereglmt"].includes(column.key)
        );
      default:
        return [...columns];
    }
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };
  const handleYearChangeExercises = (value) => {
    setSelectedYear(value);
  };

  const applyGlobalSearch = (data, searchValue) => {
    const normalizedSearch = (searchValue || "").trim().toLowerCase();
    if (!normalizedSearch) {
      return data;
    }

    return data.filter((item) =>
      Object.values(item || {}).some(
        (val) => val && val.toString().toLowerCase().includes(normalizedSearch)
      )
    );
  };

  const handleSearch = (value) => {
    setGlobalSearchValue(value);
    handleSearchFourn(searchFilters, value);
  };

  const handleSearchFourn = (values, searchValue = globalSearchValue) => {
    let filteredData = [...tableData]; // Cloner la table de données pour éviter les modifications directes

    Object.keys(values).forEach((key) => {
      if (values[key]) {
        filteredData = filteredData.filter((item) => {
          if (key === "daterecep" || key === "datefact") {
            const dateRange = values[key]; // Obtenir le tableau de dates

            if (Array.isArray(dateRange) && dateRange.length === 2) {
              const [startDate, endDate] = dateRange;

              // Assurez-vous que les dates sont formatées correctement avec dayjs
              const formattedStartDate = dayjs.isDayjs(startDate)
                ? startDate.format("YYYY-MM-DD")
                : startDate;
              const formattedEndDate = dayjs.isDayjs(endDate)
                ? endDate.format("YYYY-MM-DD")
                : endDate;

              // Comparer les dates dans les items en s'assurant que les dates de l'item sont aussi au bon format
              return (
                dayjs(item[key], "YYYY-MM-DD").isSameOrAfter(
                  formattedStartDate
                ) &&
                dayjs(item[key], "YYYY-MM-DD").isSameOrBefore(formattedEndDate)
              );
            }
          } else {
            // Pour les autres types de recherches
            return item[key]
              ?.toString()
              .toLowerCase()
              .includes(values[key].toLowerCase());
          }
        });
      }
    });

    const globallyFilteredData = applyGlobalSearch(filteredData, searchValue);
    setFilteredData(globallyFilteredData); // Mettre à jour les données filtrées
  };

  useEffect(() => {
    handleSearchFourn(searchFilters, globalSearchValue);
  }, [searchFilters, tableData, globalSearchValue]);

  const fetchSpecialite = async () => {
    setLoadingSpecialites(true);
    try {
      const specialites = await specialistesService.getAllSpecialites();
      setSpecialitesData(specialites);
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    } finally {
      setLoadingSpecialites(false); // Termine le chargement
    }
  };
  const handleFournisPrescChange = async (value) => {
    setLoadingFournisseurs(true);
    try {
      const allFournisseurs = await fournisseurService.getAllListFournis();
      // Filtrer les fournisseurs en fonction de la spécialité sélectionnée
      const prescripteurs = allFournisseurs.filter(
        (fournisseur) => fournisseur.codespe === value
      );

      setPrescripteursData(prescripteurs);
      setIsPrescripteurSelectEnabled(!!value);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des prescripteurs :",
        error
      );
    } finally {
      setLoadingFournisseurs(false); // Termine le chargement
    }
  };
  const formatNumberWithSeparator = (number) => {
    // Convertit en nombre au cas où l'entrée n'est pas déjà un nombre
    const num = Number(number);
    return num.toLocaleString("fr-FR"); // Utilisez 'fr-FR' ou une autre locale appropriée
  };

  const monthOptions = [
    { value: "01", label: "Janvier" },
    { value: "02", label: "Février" },
    { value: "03", label: "Mars" },
    { value: "04", label: "Avril" },
    { value: "05", label: "Mai" },
    { value: "06", label: "Juin" },
    { value: "07", label: "Juillet" },
    { value: "08", label: "Août" },
    { value: "09", label: "Septembre" },
    { value: "10", label: "Octobre" },
    { value: "11", label: "Novembre" },
    { value: "12", label: "Décembre" },
    { value: "13", label: "Tous les mois" },
  ];

  const monthOptionsImp = [
    { value: "01", label: "Janvier" },
    { value: "02", label: "Février" },
    { value: "03", label: "Mars" },
    { value: "04", label: "Avril" },
    { value: "05", label: "Mai" },
    { value: "06", label: "Juin" },
    { value: "07", label: "Juillet" },
    { value: "08", label: "Août" },
    { value: "09", label: "Septembre" },
    { value: "10", label: "Octobre" },
    { value: "11", label: "Novembre" },
    { value: "12", label: "Décembre" },

  ];

  useEffect(() => {
    const calculateMontantNet = () => {
      const freel = freelValue || 0;
      const remise = remiseValue || 0;
      const ristourne = ristourneValue || 0;
      const agent = agentValue || 0;

      // Votre logique de calcul ici
      return freel - remise - ristourne - agent;
    };

    const montantNet = calculateMontantNet();

    // Mise à jour de l'état avec le nouveau montant net
    setMontantNetAffiche(montantNet);

    // Si vous utilisez Ant Design Form, vous pouvez également vouloir mettre à jour le champ du formulaire directement pour refléter le nouveau montant net
    form.setFieldsValue({ montfact: montantNet });
  }, [freelValue, remiseValue, ristourneValue, agentValue, form]);


  // Gestion de la sélection des lignes
  const onSelectChange = (newSelectedRowKeys) => {
    console.log("Selected row keys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };




  const allRowKeys = filteredData.map((record) => record.numenreg);

  const handleSelectAllChange = (e) => {
    setSelectedRowKeys(e.target.checked ? allRowKeys : []);
  };

  const rowSelection = {
    selectedRowKeys,
    columnTitle: (
      <Checkbox
        checked={allRowKeys.length > 0 && selectedRowKeys.length === allRowKeys.length}
        indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < allRowKeys.length}
        onChange={handleSelectAllChange}
      />
    ),
    onChange: onSelectChange, // Utilisation de la fonction nommée

    selections: [
      {
        key: "select-all",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CheckSquareOutlined style={{ color: "#52c41a" }} />
            Sélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          const allKeys = tableData.map((item) => item.numenreg);
          setSelectedRowKeys(allKeys);
          onSelectChange(allKeys); // Appel explicite pour inclure la logique de validation
        },
      },
      {
        key: "clear-selection",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CloseSquareOutlined style={{ color: "#ff4d4f" }} />
            Désélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          setSelectedRowKeys([]);
          onSelectChange([]); // Appel explicite avec un tableau vide
        },
      },
    ],

    getCheckboxProps: (record) => ({
      name: record.numenreg,
    }),
  };



  const handleCheckboxChange = (e) => {
    const { value } = e.target;
    if (e.target.value === "Prepaid") {
      showModal1();
    }
    if (checkedValue === value) {
      setCheckedValue("");
    } else {
      setCheckedValue(value);
    }
  };
  const showModal1 = () => {
    setIsModalVisible1(true);
  };

  const handleConfirm = () => {
    setConfirmedMontantPrepaye(montantPrepaye); // Met à jour l'état avec le montant prépayé
    setIsModalVisible1(false); // Ferme la modal
  };
  const handleCancel1 = () => {
    setIsModalVisible1(false);
    setMontantPrepaye(0); // Optionnel, réinitialiser le montant si annulé
  };

  const showModalrejet = () => {
    setIsModalRejet(true);
  };

  const handleCancelRejet = () => {
    setIsModalRejet(false);
    form.resetFields();
  };
  const showModalVentil = () => {
    setIsModalventil(true);
  };

  const handleCancelVentil = () => {
    setIsModalventil(false);
    form.resetFields();
  };

  const handleRefresh = (values) => {
    setRefreshTable(!refreshTable);
    setSearchFilters(!values);
  };

  const showModal = (isEdit, record) => {
    setIsEditMode(isEdit);

    if (isEdit) {
      setSelectedNumenreg(record.numenreg);

      const montantNet = calculateMontantNetFromRecord(record);

      form.setFieldsValue({
        ...record,
        numfact: record.numfact,
        montfact: montantNet,
        nature_fact: record.nature_fact,
        typereglmt: record.typereglmt,
        datefact: record.datefact ? dayjs(record.datefact) : null,
        daterecep: record.daterecep ? dayjs(record.daterecep) : null,
      });

      // Mettre à jour l'état checkedValue en fonction de record.rembourse
      if (record.rembourse === "oui") {
        setCheckedValue("rembourse");
      } else if (record.nature_fact === "Prepaid") {
        setCheckedValue("Prepaid");
      } else if (record.nature_fact === "Avoir") {
        setCheckedValue("Avoir");
      } else {
        setCheckedValue("Normale");
      }

      setModalTitle("Modifier Facture");
      fetchSpecialite();
      handleFournisPrescChange(record.codespe);
      setMontantNetAffiche(montantNet);
    } else {
      setSelectedNumenreg(null);
      form.resetFields();
      form.setFieldsValue({ daterecep: dayjs() });
      setCheckedValue("Normale"); // Reset to default state
      setMontantNetAffiche(0);
      setModalTitle("Réception Facture");
    }

    fetchSpecialite();
    setIsModalVisible(true);
  };
  useEffect(() => {
    // Récupérer les valeurs actuelles du formulaire pour le calcul
    const values = form.getFieldsValue([
      "freel",
      "remise",
      "ristourne",
      "qp_agent",
    ]);

    // Calculer le montant net facturé en fonction des valeurs du formulaire
    const montantNet = calculateMontantNetFromRecord(values);

    // Mettre à jour l'affichage du montant net
    setMontantNetAffiche(montantNet);

    // Le useEffect s'exécutera à chaque changement de ces valeurs
  }, [
    form.getFieldValue("freel"),
    form.getFieldValue("remise"),
    form.getFieldValue("ristourne"),
    form.getFieldValue("qp_agent"),
  ]);

  const calculateMontantNetFromRecord = (record) => {
    const freel = Number(record.freel) || 0;
    const remise = Number(record.remise) || 0;
    const ristourne = Number(record.ristourne) || 0;
    const agent = Number(record.qp_agent) || 0;

    return freel - remise - ristourne - agent;
  };

  const totalDebit = annulationPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.debit || 0),
    0
  );
  const totalCredit = annulationPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.credit || 0),
    0
  );
  const solde = totalDebit - totalCredit;

  const totalDebit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.debit || 0),
    0
  );
  const totalCredit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.credit || 0),
    0
  );
  const solde1 = totalDebit1 - totalCredit1;

  const handleCancel = () => {
    form.resetFields();
    setIsPrescripteurSelectEnabled(false);
    setFreelValue(0);
    setRistourneValue(0);
    setRemiseValue(0);
    setAgentValue(0);

    setIsModalVisible(false);
  };

  const showFileModal = (numenreg) => {
    setSelectedNumenreg(numenreg);
    setIsFileModalVisible(true);
  };

  const hideFileModal = () => {
    setIsFileModalVisible(false);
  };

  const handleImportFile = async () => {
    setIsFileUploading(true);
    try {
      // Ouvrir le sélecteur de fichiers
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.addEventListener("change", async (event) => {
        const selectedFile = event.target.files[0];
        // La logique d'importation du fichier
        const formData = new FormData();
        formData.append("facture", selectedFile);
        const response = await traitementsoinsService.ImportFile(
          selectedNumenreg,
          formData
        );
        console.log(response);
        // Fermez la modal
        hideFileModal();
      });
      fileInput.click();
    } catch (error) {
      console.error("Erreur lors de l'importation du fichier :", error);
    } finally {
      setIsFileUploading(false);
    }
  };

  const handlePrintClick = () => {
    setIsPrintModalVisible(true);
  };

  const handleExportToExcel = async () => {
    const { getFieldValue } = form;
    const codeadht = getFieldValue("codeadht");
    const month = selectedMonth;
    const year = selectedYear;
    try {
      await traitementsoinsService.exportEtatsMensuels(year, month, codeadht);
      setIsPrintModalVisible(false);

      form.resetFields();
    } catch (error) {
      console.error("Erreur lors de l'exportation :", error);
    }
  };

  // Noms d'onglet Excel : 31 caractères max, certains caractères interdits ( \ / ? * [ ] : ),
  // et unicité à garantir si plusieurs sociétés partagent le même intitulé une fois tronqué.
  const sanitizeSheetName = (name, usedNames) => {
    let base = String(name || "Feuille").replace(/[\\/?*[\]:]/g, "").trim() || "Feuille";
    base = base.substring(0, 31);
    let candidate = base;
    let suffix = 1;
    while (usedNames.has(candidate)) {
      const suffixStr = ` (${suffix})`;
      candidate = base.substring(0, 31 - suffixStr.length) + suffixStr;
      suffix += 1;
    }
    usedNames.add(candidate);
    return candidate;
  };

  const fetchOrderedImputationsRows = async () => {
    const { getFieldValue } = form;
    const codeadht = getFieldValue("codeadht");
    const month = selectedMonth;
    const year = selectedYear;
    const listCompta = await factureService.getListImputationsMensExcel(year, month, codeadht);

    // Ordre des colonnes imposé par le modèle export_imputationsMens_excel.xlsx
    // (le champ matricule est exposé sous la clé "matri" dans la réponse de l'API)
    const orderedRows = (listCompta || []).map((row) => ({
      codesoc: row.codesoc,
      intitule: row.intitule,
      matricule: row.matri,
      participant: row.participant,
      debit: row.debit,
    }));

    return { orderedRows, codeadht, year, month };
  };

  const handleExportSingleSheet = async () => {
    try {
      const { orderedRows, codeadht, year, month } = await fetchOrderedImputationsRows();

      if (orderedRows.length === 0) {
        message.warning("Aucune donnée à exporter.");
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(orderedRows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Imputations");

      // Onglet RECAP : total du montant par société, avec un Grand Total en dernière ligne
      const recapByCodesoc = new Map();
      orderedRows.forEach((row) => {
        const key = row.codesoc || "-";
        if (!recapByCodesoc.has(key)) {
          recapByCodesoc.set(key, { societe: row.intitule, montant: 0 });
        }
        recapByCodesoc.get(key).montant += Number(row.debit) || 0;
      });

      const grandTotal = Array.from(recapByCodesoc.values()).reduce(
        (sum, { montant }) => sum + montant,
        0
      );

      const recapAoa = [
        ["Code", "Société", "Montant"],
        ...Array.from(recapByCodesoc.entries()).map(([code, { societe, montant }]) => [
          code,
          societe,
          montant,
        ]),
        ["Grand Total", "", grandTotal],
      ];

      const recapWorksheet = XLSX.utils.aoa_to_sheet(recapAoa);
      recapWorksheet["!cols"] = [{ wch: 8 }, { wch: 50 }, { wch: 13 }];
      XLSX.utils.book_append_sheet(workbook, recapWorksheet, "RECAP");

      XLSX.writeFile(workbook, `Etats_Imputations_${codeadht}_${year}_${month}.xlsx`);
    } catch (error) {
      console.error("Erreur lors de l'exportation des états Excel :", error);
      message.error("Erreur lors de l'exportation des états Excel.");
    }
  };

  const handleExportBySociete = async () => {
    try {
      const { orderedRows, codeadht, year, month } = await fetchOrderedImputationsRows();

      if (orderedRows.length === 0) {
        message.warning("Aucune donnée à exporter.");
        return;
      }

      const groupsByCodesoc = new Map();
      orderedRows.forEach((row) => {
        const key = row.codesoc || "-";
        if (!groupsByCodesoc.has(key)) {
          groupsByCodesoc.set(key, { intitule: row.intitule, rows: [] });
        }
        groupsByCodesoc.get(key).rows.push(row);
      });

      const monthLabel = (monthOptionsImp.find((m) => m.value === month)?.label || "").toUpperCase();

      const workbook = XLSX.utils.book_new();
      const usedNames = new Set();
      groupsByCodesoc.forEach(({ intitule, rows }) => {
        const title = `ETAT IMPUTATIONS ${monthLabel} ${year} - ${intitule}`;
        const totalMontant = rows.reduce((sum, row) => sum + (Number(row.debit) || 0), 0);
        const aoa = [
          [],
          [title, "", ""],
          [],
          ["Matricule ", "Participant", "Montant"],
          ...rows.map((row) => [row.matricule, row.participant, row.debit]),
          ["", "Total", totalMontant],
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(aoa);
        worksheet["!merges"] = [{ s: { r: 1, c: 0 }, e: { r: 1, c: 2 } }];
        worksheet["!cols"] = [{ wch: 10 }, { wch: 26 }, { wch: 11 }];

        const sheetName = sanitizeSheetName(intitule, usedNames);
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      });

      XLSX.writeFile(workbook, `Etats_Imputations_${codeadht}_${year}_${month}_par_societe.xlsx`);
    } catch (error) {
      console.error("Erreur lors de l'exportation des états Excel par société :", error);
      message.error("Erreur lors de l'exportation des états Excel par société.");
    }
  };

  const exportExcel = (data, fileName = "export_excel.xlsx") => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, fileName);
  };


  const handlePrintModalCancel = () => {
    setIsPrintModalVisible(false);

    form.resetFields();
  };

  const etatDescriptions = [
    { value: "A", label: "Toutes" },
    { value: "R", label: "Reçues" },
    /*  { value: "S", label: "En cours" }, */
    { value: "T", label: "Traitées" },
    { value: "C", label: "Comptabilisées" },
    { value: "P", label: "Payées" },
    { value: "J", label: "Rejetées" },
  ];


  const handleRegenerefactsoin = async (record) => {
    // `record` contient toutes les données de la ligne que tu veux régénérer
    const numenreg = record.numenreg;

    try {
      const response = await traitementsoinsService.RegenereFactureSoin(
        numenreg,
        record
      );
      message.success("La facture a été régénérée avec succès!");
      // Met à jour les données dans ton interface utilisateur ici, si nécessaire
      fetchDataByOption(selectedOption); // Rafraîchir les données affichées si nécessaire
    } catch (error) {
      message.error("Erreur lors de la régénération de la facture.");
      console.error("Erreur lors de la régénération de la facture :", error);
    }
  };

  const handleUpdate = async () => {
    try {
      // Assurez-vous que selectedNumenreg est correctement défini à ce stade
      if (selectedNumenreg) {
        const values = await form.validateFields();
        const selectedFournisseur = prescripteursData.find(
          (fournisseur) => fournisseur.numFourn === values.numfourn
        );
        const raisoc = selectedFournisseur ? selectedFournisseur.raisoc : "";

        const payload = {
          avoir: checkedValue === "Avoir" ? true : "",
          datefact: values.datefact.toISOString(),
          daterecep: values.daterecep.toISOString(),
          delai: 60,
          freel: values.freel,
          montfact: montantNetAffiche,
          numenreg: selectedNumenreg,
          numfact: values.numfact,
          nature_fact: values.nature_fact,
          numfourn: values.numfourn,
          qp_agent: values.qp_agent,
          mont_prepaid: values.mont_prepaid,
          raisoc: raisoc,
          rembourse: checkedValue === "rembourse" ? "oui" : "non",
          remise: values.remise,
          ristourne: values.ristourne,
          typefact: "S",
          typeremb: values.typeremb,
        };

        const response = await traitementsoinsService.EditFacture(
          selectedNumenreg,
          payload
        );
        console.log("Mise à jour réussie :", response);
        fetchDataByOption(selectedOption);
        // Effectuez des actions post-mise à jour ici (par exemple, fermez le modal, affichez un message de succès, rafraîchissez les données affichées, etc.)
        setIsModalVisible(false);
        form.resetFields();
        // Optionnel : rafraîchissez les données de la facture ou l'état de l'application selon vos besoins
      } else {
        console.error("Numenreg non défini");
        // Gérez l'erreur (par exemple, en affichant un message d'erreur à l'utilisateur)
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la facture :", error);
      // Gérez l'affichage des erreurs ici
    }
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      const selectedFournisseur = prescripteursData.find(
        (fournisseur) => fournisseur.numFourn === values.numfourn
      );
      const raisoc = selectedFournisseur ? selectedFournisseur.raisoc : "";
      const docData = {
        avoir: checkedValue === "Avoir" ? true : "",

        datefact: values.datefact.toISOString(),
        daterecep: values.daterecep.toISOString(),
        delai: 60,
        freel: values.freel,
        montfact: montantNetAffiche,
        numenreg: null,
        numfourn: values.numfourn,
        numfact: values.numfact,
        prepaid: checkedValue === "prepaid" ? "prepaid" : "",
        qp_agent: values.qp_agent,
        mont_prepaid: values.mont_prepaid,
        raisoc: raisoc,
        rembourse: checkedValue === "rembourse" ? "oui" : "non",
        remise: values.remise,
        ristourne: values.ristourne,
        typefact: "S",
        typeremb: values.typeremb,
      };

      // Ajout de nouveau document
      const data = await traitementsoinsService.AddFacture(docData);
      console.log("Réponse du serveur après l'ajout de la facture :", data);
      // Vérification si l'ajout doit se faire dans la catégorie 'Reçue'
      if (selectedOption === "R" && data.etat === "R") {
        setFilteredData([...tableData, data]);
      }
      // Récupération à nouveau les données en fonction de l'option sélectionnée
      fetchDataByOption(selectedOption);
      // Réinitialisation du formulaire et fermez la fenêtre modale
      form.resetFields();
      // handleCancel();
      setIsPrescripteurSelectEnabled(false);
      setFreelValue(0);
      setRistourneValue(0);
      setRemiseValue(0);
      setAgentValue(0);
      setCheckedValue("Normale");
    } catch (error) {
      console.error("Erreur lors de handleOk :", error);
    }
  };

  const handleNavigateToTraitementFacture = (record) => {
    navigate(`/factures/show/${record.numenreg}`, { state: { record } });
  };

  // Réinitialise les données affichées (filtres colonnes) chaque fois que la source change
  useEffect(() => {
    setDisplayedInvoiceData(filteredData);
  }, [filteredData]);

  const handleInvoiceTableChange = (pagination, filters, sorter, extra) => {
    setDisplayedInvoiceData(extra.currentDataSource);
  };

  const totalMontant = displayedInvoiceData.reduce(
    (acc, curr) => acc + curr.montfact,
    0
  );
  const nombreFactures = displayedInvoiceData.length;

  const renderActionsMenu = (text, record) => {
    let menuItems = [];

    switch (selectedOption) {
      case "R":
        menuItems = [
          <Menu.Item
            key="traitement"
            onClick={() => handleNavigateToTraitementFacture(record)}
          >
            <EyeOutlined style={{ color: "#4DBD74" }} />
            Traitement facture
          </Menu.Item>,
          <Menu.Item
            key="edit"
            icon={<EditOutlined style={{ color: "#1890ff" }} />}
            onClick={() => showModal(true, record)}
          >
            Modifier Facture
          </Menu.Item>,
          // <Menu.Item
          //   key="charger"
          //   icon={<CloudUploadOutlined style={{ color: "#1890ff" }} />}
          //   onClick={() => showFileModal(record.numenreg)}
          // >
          //   Charger Facture
          // </Menu.Item>,
          // <ExportFacture key="export" numenreg={record.numenreg} />,
          <Menu.Item
            key="delete"
            icon={<DeleteOutlined style={{ color: "red" }} />}
            onClick={() => handleDeleteline(record.numenreg)}
          >
            Supprimer Facture
          </Menu.Item>,
        ];
        break;
      case "S":
        menuItems = [
          <Menu.Item
            key="traitement"
            onClick={() => handleNavigateToTraitementFacture(record)}
          >
            <EyeOutlined style={{ color: "#4DBD74" }} />
            Traitement facture
          </Menu.Item>,
          <Menu.Item
            key="edit"
            icon={<EditOutlined style={{ color: "#1890ff" }} />}
            onClick={() => showModal(true, record)}
          >
            Modifier Facture
          </Menu.Item>,
          // <Menu.Item
          //   key="charger"
          //   icon={<CloudUploadOutlined style={{ color: "#1890ff" }} />}
          //   onClick={() => showFileModal(record.numenreg)}
          // >
          //   Charger Facture
          // </Menu.Item>,
          // <ExportFacture key="export" numenreg={record.numenreg} />,
          <Menu.Item
            key="delete"
            icon={<DeleteOutlined style={{ color: "red" }} />}
            onClick={() => handleDeleteline(record.numenreg)}
          >
            Supprimer Facture
          </Menu.Item>,
        ];
        break;
      case "A":
        menuItems = [
          // <Menu.Item
          //   key="charger"
          //   icon={<CloudUploadOutlined style={{ color: "#1890ff" }} />}
          //   onClick={() => showFileModal(record.numenreg)}
          // >
          //   Charger Facture
          // </Menu.Item>,
          // <ExportFacture key="export" numenreg={record.numenreg} />,
        ];
        break;
      case "T":
        menuItems = [
          <Menu.Item
            key="traitement"
            onClick={() => handleNavigateToTraitementFacture(record)}
          >
            <EyeOutlined style={{ color: "#4DBD74" }} />
            Traitement facture
          </Menu.Item>,

          <Popconfirm
            title="Êtes-vous sûr de vouloir regénerer cette facture ?"
            onConfirm={() => handleRegenerefactsoin(record)}
            okText="Oui"
            cancelText="Non"
          >
            <Menu.Item
              key="regenere"
              icon={<UploadOutlined style={{ color: "#1890ff" }} />}
            // onClick={() => handleRegenerefactsoin(record)} // `record` doit être défini dans le contexte où cette ligne est exécutée
            > Regénérer La Facture</Menu.Item>
          </Popconfirm>,
          // <Menu.Item
          //   key="charger"
          //   icon={<CloudUploadOutlined style={{ color: "#1890ff" }} />}
          //   onClick={() => showFileModal(record.numenreg)}
          // >
          //   Charger Facture
          // </Menu.Item>,
          // <ExportFacture key="export" numenreg={record.numenreg} />,
        ];
        break;
      case "C":
        menuItems = [
          // <Menu.Item
          //   key="charger"
          //   icon={<CloudUploadOutlined style={{ color: "#1890ff" }} />}
          //   onClick={() => showFileModal(record.numenreg)}
          // >
          //   Charger Facture
          // </Menu.Item>,
          // <ExportFacture key="export" numenreg={record.numenreg} />,
          <Menu.Item
            key="annulation"
            icon={<CloseCircleOutlined style={{ color: "#1890ff" }} />}
            onClick={() => handleAnnulationComptabilisation(record.numenreg)}
          >
            Annulation Comptabilisation
          </Menu.Item>,
        ];
        break;

      case "P":
        menuItems = [
          // <Menu.Item
          //   key="charger"
          //   icon={<CloudUploadOutlined style={{ color: "#1890ff" }} />}
          //   onClick={() => showFileModal(record.numenreg)}
          // >
          //   Charger Facture
          // </Menu.Item>,
          // <ExportFacture key="export" numenreg={record.numenreg} />,
        ];
        break;

      default:
        menuItems = [
          // <Menu.Item
          //   key="charger"
          //   icon={<CloudUploadOutlined style={{ color: "#1890ff" }} />}
          //   onClick={() => showFileModal(record.numenreg)}
          // >
          //   Charger Facture
          // </Menu.Item>,
          // <ExportFacture key="export" numenreg={record.numenreg} />,
        ];
        break;
    }

    return (
      <Dropdown overlay={<Menu>{menuItems}</Menu>}>
        <Button
          type="text"
          icon={
            <EllipsisOutlined
              style={{ transform: "rotate(90deg)", transition: "color 0.3s" }}

            />
          }
          style={{ color: "#FFFF" }}
          className="custom-button"
        />
      </Dropdown>
    );
  };
  const columns = [
    {
      title: "N° Enreg",
      dataIndex: "numenreg",
      key: "numenreg",
      align: "center",
      fixed: "left",
      /*  */
      sorter: (a, b) => a.numenreg - b.numenreg,
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", fontWeight: "bold" }}>{text}</div>
      ),
    },
    {
      title: "N° facture Frs",
      dataIndex: "numfact",
      key: "numfact",
      align: "center",

      sorter: (a, b) => a.numfact - b.numfact,
    },
    {
      title: "Date F.",
      dataIndex: "datefact",
      key: "datefact",
      align: "center",
      sorter: (a, b) => moment(a.datefact).unix() - moment(b.datefact).unix(),
      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {moment(text).locale("fr").format("DD/MM/YYYY")}{" "}
        </div>
      ),
    },
    {
      title: "Reçu le",
      dataIndex: "daterecep",
      key: "daterecep",
      align: "center",
      sorter: (a, b) => moment(a.daterecep).unix() - moment(b.daterecep).unix(),

      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {" "}
          {moment(text).locale("fr").format("DD/MM/YYYY")}{" "}
        </div>
      ),
    },
    {
      title: "Saisie le",
      dataIndex: "datesaisie",
      key: "datesaisie",

      sorter: (a, b) =>
        moment(a.datesaisie).unix() - moment(b.datesaisie).unix(),
      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {" "}
          {moment(text).locale("fr").format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      title: "Traitée le",
      dataIndex: "date_process",
      key: "date_process",
      align: "center",
      sorter: (a, b) =>
        moment(a.date_process).unix() - moment(b.date_process).unix(),

      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {moment(text).locale("fr").format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      title: "Date compta",
      dataIndex: "datecompta",
      key: "datecompta",
      align: "center",
      sorter: (a, b) =>
        moment(a.datecompta).unix() - moment(b.datecompta).unix(),

      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {moment(text).locale("fr").format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      title: "Echéance",
      dataIndex: "echeance",
      key: "echeance",
      align: "center",
      sorter: (a, b) => moment(a.echeance).unix() - moment(b.echeance).unix(),

      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {moment(text).locale("fr").format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      title: "Payée le",
      dataIndex: "datereglmt",
      key: "datereglmt",
      align: "center",
      sorter: (a, b) =>
        (a.datereglmt ? moment(a.datereglmt).unix() : 0) -
        (b.datereglmt ? moment(b.datereglmt).unix() : 0),

      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {text ? moment(text).locale("fr").format("DD/MM/YYYY") : ""}
        </div>
      ),
    },
    {
      title: "Mois Compta.",
      dataIndex: "datetrait",
      key: "datetrait",
      align: "center",
      sorter: (a, b) => moment(a.datetrait).unix() - moment(b.datetrait).unix(),

      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center", backgroundColor: "#ADD8E6" }}>
          <b>{moment(text).locale("fr").format("MMM-YYYY")}</b>
        </div>
      ),
    },
    {
      title: "Montant",
      dataIndex: "montfact",
      key: "montfact",
      align: "right",
      sorter: (a, b) => a.montfact - b.montfact,
      filters: [
        { text: "100 - 100,000", value: "100-100000" },
        { text: "100,000 - 1,000,000", value: "100000-1000000" },
        { text: "Plus de 1,000,000", value: "1000000-" },
      ],
      onFilter: (value, record) => {
        if (value.endsWith("-")) {
          const min = Number(value.split("-")[0]);
          return record.montfact >= min;
        } else {
          const [min, max] = value.split("-").map(Number);
          return record.montfact >= min && record.montfact <= max;
        }
      },
      render: (text, record) => {
        const formattedNumber = formatNumberWithSeparator(text);
        const textColor = record.nature_fact === "Avoir" ? "red" : "blue";
        return (
          <span
            style={{
              color: textColor,
              paddingRight: "5px",
              fontWeight: "bold",
              transition: "color 0.3s",
            }}
            className="montant-cell"
          >
            {formattedNumber}
          </span>
        );
      },
    },

    {
      title: "N° Frs",
      dataIndex: "numfourn",
      key: "numfourn",
      align: "center",
      filters: [
        ...new Set(
          tableData.map((item) => item?.numfourn).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        )
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.numfourn === value,
      sorter: (a, b) => a.numfourn - b.numfourn,
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
          <span style={{ fontWeight: 500 }}>{text || " "}</span>
          <Tooltip title="Voir ce fournisseur">
            <ArrowRightOutlined
              style={{
                cursor: "pointer",
                color: "#1890ff",
                fontSize: 12,
                transition: "color 0.2s",
              }}
              onClick={() => {
                navigate(`/fournisseurs/view/${record.numfourn}`);
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#40a9ff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#1890ff";
              }}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: "Fournisseur",
      dataIndex: "raisoc",
      key: "raisoc",
      filters: [
        ...new Set(
          tableData.map((item) => item?.raisoc).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        )
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.raisoc === value,

      sorter: (a, b) => a.raisoc - b.raisoc,
      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Spécialité",
      dataIndex: "intitule",
      key: "intitule",
      filters: [
        ...new Set(
          tableData.map((item) => item?.intitule).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        )
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.intitule === value,

      sorter: (a, b) => a.intitule - b.intitule,
      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Saisie par",
      dataIndex: "created_by",
      key: "created_by",
      align: "center",
      filters: [
        ...new Set(
          tableData.map((item) => item?.created_by).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        )
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.created_by === value,
      sorter: (a, b) => a.created_by - b.created_by,
    },
    {
      title: "Traitée par",
      dataIndex: "process_by",
      key: "process_by",
      filters: [
        ...new Set(
          tableData.map((item) => item?.process_by).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        )
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.process_by === value,
      sorter: (a, b) => a.process_by - b.process_by,
    },
    {
      title: "Comptabilisée par",
      dataIndex: "compta_by",
      key: "compta_by",
      filters: [
        ...new Set(
          tableData.map((item) => item?.compta_by).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        )
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.compta_by === value,

      sorter: (a, b) => a.compta_by - b.compta_by,
    },
    {
      title: "Etat",
      dataIndex: "etat",
      key: "etat",
      align: "center",
      filters: [
        ...new Set(
          tableData.map((item) => item?.etat).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        )
      ].map((value) => {
        let tagText;
        switch (value) {
          case "R":
            tagText = "reçue";
            break;
          case "J":
            tagText = "rejetée";
            break;
          case "C":
            tagText = "Comptabilisée";
            break;
          case "T":
            tagText = "traitée";
            break;
          case "S":
            tagText = "en cours";
            break;
          case "P":
            tagText = "Payée";
            break;
          default:
            tagText = "Inconnu";
        }
        return {
          text: tagText // Affichage dans le filtre
          , value: value  // Correspondance avec la donnée dans le tableau
        };
      }),
      onFilter: (value, record) => record.etat === value,
      sorter: (a, b) => a.etat.localeCompare(b.etat),
      render: (text) => {
        let tagColor, tagText;
        switch (text) {
          case "R":
            tagColor = "#46de04";
            tagText = "reçue";
            break;
          case "J":
            tagColor = "#c0392b";
            tagText = "rejetée";
            break;
          case "C":
            tagColor = "#f2b305";
            tagText = "Comptabilisée";
            break;
          case "T":
            tagColor = "#fa0202";
            tagText = "traitée";
            break;
          case "S":
            tagColor = "#fa0202";
            tagText = "en cours";
            break;
          case "P":
            tagColor = "#1890ff";
            tagText = "Payée";
            break;
          default:
            tagColor = "gray";
            tagText = "Inconnu";
        }

        return (
          <Tag color={tagColor} align="center">
            {tagText}
          </Tag>
        );
      },
    },

    {
      title: "Type",
      dataIndex: "nature_fact",
      key: "nature_fact",
      filters: [
        ...new Set(
          tableData.map((item) => item?.nature_fact).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        )
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.nature_fact === value,
      align: "center",
      sorter: (a, b) => a.nature_fact - b.nature_fact,
      render: (text) => {
        let tagColor, tagText, tagalign;
        switch (text) {
          case "Normale":
            tagColor = "#46de04";
            tagText = "Normale";
            tagalign = "center";
            break;
          case "RIB":
            tagColor = "#f2b305";
            tagText = "RIB";
            tagalign = "center";
            break;
          case "RIC":
            tagColor = "#fa0202";
            tagText = "RIC";
            tagalign = "center";
            break;
          case "Avoir":
            tagColor = "#1890ff";
            tagText = "Avoir";
            tagalign = "center";
            break;
          case "Prepaid":
            tagColor = "#0e96ab";
            tagText = "Prepaid";
            tagalign = "center";
            break;
          default:
            tagColor = "gray";
            tagText = "Inconnu";
            tagalign = "center";
        }

        return (
          <div>
            <Tag color={tagColor} align={tagalign}>
              {tagText}
            </Tag>
          </div>
        );
      },

    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
          }}
        ></div>
      ),
      className: "small-cell",
      ellipsis: true,
      dataIndex: "actions",
      key: "actions",
      align: "center",
      fixed: "right",
      width: 50,
      render: renderActionsMenu,
    },
  ];
  const exportToExcel = (data, fileName) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const prepareDataForExport = (data) => {
    return data.map((row) => ({
      CodeJ: row.codej,
      DateCompta: row.datecompta,
      MoisTrait: row.datetrait,
      NumPiece: row.numpiece,
      NumCheque: row.numcheque,
      NumFIPM: row.numfactipm,
      CompteGen: row.comptegen,
      CompteTiers: row.comptetiers,
      Matricule: row.matri,
      Libelle: row.libelle,
      Debit: row.debit,
      Credit: row.credit,
    }));
  };


  const columns1 = [
    {
      title: "C.JL",
      dataIndex: "codej",
      key: "codej",
      align: "center",
      sorter: (a, b) => (a.codej || "").localeCompare(b.codej || ""),
    },
    {
      title: "D. Compta",
      dataIndex: "datecompta",
      key: "datecompta",
      align: "center",
      sorter: (a, b) =>
        (a.datecompta ? moment(a.datecompta).unix() : 0) -
        (b.datecompta ? moment(b.datecompta).unix() : 0),
      render: (text) => (
        <div>{text ? moment(text).format("DD/MM/YYYY") : ""}</div>
      ),
    },
    {
      title: "Mois trait.",
      dataIndex: "datetrait",
      key: "datetrait",
      align: "center",
      sorter: (a, b) =>
        (a.datetrait ? moment(a.datetrait).unix() : 0) -
        (b.datetrait ? moment(b.datetrait).unix() : 0),
      render: (text) => (
        <div>{text ? moment(text).format("MMM.YYYY") : ""}</div>
      ),
    },
    {
      title: "N° pièce",
      dataIndex: "numpiece",
      key: "numpiece",
      align: "center",
      sorter: (a, b) => (a.numpiece || "").localeCompare(b.numpiece || ""),
    },
    {
      title: "N° Chèque",
      dataIndex: "numcheque",
      key: "numcheque",
      align: "center",
      sorter: (a, b) => (a.numcheque || "").localeCompare(b.numcheque || ""),
    },
    {
      title: "N° F. IPM",
      dataIndex: "numfactipm",
      key: "numfactipm",
      align: "center",
      sorter: (a, b) => (a.numfactipm || "").localeCompare(b.numfactipm || ""),
    },
    {
      title: "Cpte. Gen.",
      dataIndex: "comptegen",
      key: "comptegen",
      align: "center",
      sorter: (a, b) => (a.comptegen || "").localeCompare(b.comptegen || ""),
    },
    {
      title: "Cpte. Tiers",
      dataIndex: "comptetiers",
      key: "comptetiers",
      align: "center",
      sorter: (a, b) => (a.comptetiers || "").localeCompare(b.comptetiers || ""),
    },
    {
      title: "Matricule",
      dataIndex: "matri",
      key: "matri",
      align: "center",
      sorter: (a, b) => (a.matri || "").localeCompare(b.matri || ""),
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      sorter: (a, b) => (a.libelle || "").localeCompare(b.libelle || ""),
    },
    {
      title: "Débit",
      dataIndex: "debit",
      key: "debit",
      align: "right",
      sorter: (a, b) => (a.debit || 0) - (b.debit || 0),
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
    },
    {
      title: "Crédit",
      dataIndex: "credit",
      key: "credit",
      align: "right",
      sorter: (a, b) => (a.credit || 0) - (b.credit || 0),
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
    },
  ];


  function formatNumber(number) {
    return new Intl.NumberFormat("fr-FR").format(number);
  }
  const handleDeleteMultiple = async () => {
    confirm({
      title: `Êtes-vous sûr de vouloir supprimer les factures sélectionnées ?`,
      okText: "Oui",
      cancelText: "Non",
      onOk: async () => {
        try {
          // Préparer le payload à partir des lignes sélectionnées
          const selectedRows = tableData.filter((row) =>
            selectedRowKeys.includes(row.numenreg)
          );

          if (selectedRows.length > 0) {
            // Prenons la première ligne sélectionnée comme référence pour le numfact et numfourn
            const { numfact, numfourn } = selectedRows[0];
            setSelectedFact({ numfact, numfourn }); // Stocker les informations dans l'état
          }


          // Appeler l'API pour supprimer les lignes
          await traitementsoinsService.deleteLines(selectedRows);

          message.success("Suppression multiple effectuée avec succès !");

          setSelectedRowKeys([]); // Réinitialise la sélection
          fetchDataByOption(selectedOption); // Rafraîchit les données après suppression
        } catch (error) {
          console.error("Erreur lors de la suppression multiple :", error);
          message.error("Erreur lors de la suppression multiple");
        }
      },
      onCancel() {
        // Action en cas d'annulation
      },
    });
  };

  const gestionMenu1 = (
    <Menu>
      <Menu.Item
        key="1"
        icon={<SyncOutlined className="buttonRefresh" />}
        onClick={handleRefresh}
      >
        Actualiser
      </Menu.Item>
      <Menu.Item
        key="2"
        icon={<CloseSquareOutlined className="buttonCloture" />}
        onClick={handleClotureMensuelle}
      >
        Cloture Mensuelle
      </Menu.Item>
      <Menu.Item
        key="2"
        icon={<ArrowLeftOutlined className="buttonCloture" />}
        onClick={handleOpenModalcompta}
        disabled={selectedRowKeys.length === 0}
      >
        Modifier Mois Compta
      </Menu.Item>
      <Menu.Item
        key="3"
        icon={<ExportOutlined className="buttonExport" />}
        onClick={() => exportToExcel(tableData, "Traitement-facture")}
      >
        Export
      </Menu.Item>
      {selectedOption === "R" && (
        <Menu.Item
          key="5"
          icon={<DeleteOutlined style={{ color: "red" }} />}
          onClick={handleDeleteMultiple}
          disabled={selectedRowKeys.length === 0} // Désactiver si aucune ligne n'est sélectionnée
        >
          Supprimer
        </Menu.Item>
      )}
    </Menu>
  );

  const handleCancelPreview = () => {
    setIsPreviewModalVisible(false);
  };

  const handlePreview = async () => {
    const payload = selectedRowKeys.map(
      (key) => tableData.find((item) => item.numenreg === key).numenreg
    );

    console.log("Payload:", payload); // Vérifiez le contenu du payload

    try {
      const hideMessage = message.loading("Chargement des données...", 0);

      await traitementsoinsService.updatedPayloadPrint(payload);
      console.log("updatedPayloadPrint success"); // Vérifiez si cette étape est réussie

      // Commentez l'appel à getPreviewData pour l'instant
      const data = await traitementsoinsService.previewImputPayload(payload);
      setPreviewData(data);
      setIsPreviewModalVisible(true);

      hideMessage();
    } catch (error) {
      message.error(
        "Erreur lors de la récupération des données de prévisualisation."
      );
      console.error(
        "Erreur lors de la récupération des données de prévisualisation :",
        error
      );
    }
  };

  const handlePrintVentil = async () => {
    const payload = selectedRowKeys.map(
      (key) => tableData.find((item) => item.numenreg === key).numenreg
    );
    const month = selectedMonth;
    const year = selectedYear;
    const docName = "VentilationFact_IPM";
    try {
      const hideMessage = message.loading("Impression en cours...", 0);
      await traitementsoinsService.updatedPayloadPrint(payload);
      console.log("updatedVentilationPrint successfully called");
      traitementsoinsService.printVentilationService(
        docName,
        year,
        month
      );
      hideMessage(); // Masquer le message de chargement après la réussite
      message.success("Impression réussie!");
    } catch (error) {
      console.error("Erreur lors de l'impression :", error);
    }

    setIsModalventil(false); // Fermer la modal après l'impression
  };

  const handlePrintRejet = async () => {
    try {
      const values = await form.validateFields();
      const motifRejet = values.motif_rejet;

      const numenreg = selectedRowKeys.map(
        (key) => tableData.find((item) => item.numenreg === key).numenreg
      );
      const docName = "Fiche_Rejet";

      if (docName.includes("Rejet")) {
        const hideMessage = message.loading("Impression en cours...", 0); // Afficher le message de chargement

        try {
          for (const num of numenreg) {
            const record = tableData.find((item) => item.numenreg === num);
            await traitementsoinsService.UpdatePrinted(num, {
              ...record,
              motif_rejet: motifRejet, // Inclure le motif de rejet
            });
          }
          console.log("updatePrinted successfully called");

          traitementsoinsService.printRejetService(docName, numenreg);

          hideMessage(); // Masquer le message de chargement après la réussite
          message.success("Impression réussie!");
        } catch (error) {
          hideMessage(); // Masquer le message de chargement en cas d'erreur
          message.error("Erreur lors de l'impression.");
          console.error("Erreur lors de l'impression :", error);
        }
      } else {
        console.error("Invalid docName");
      }

      setIsModalRejet(false); // Fermer la modal après l'impression
    } catch (error) {
      console.error("Erreur lors de la validation du formulaire :", error);
    }
  };

  const handlePrintListFacture = async () => {
    console.log(selectedType)
    const type = selectedType;
    const month = selectedMonth;
    const year = selectedYear;
    const docName = "List_Factures_Compta";

    const hideMessage = message.loading("Impression en cours...", 0);
    try {
      traitementsoinsService.printListFactureService(
        year,
        month,
        type,
        docName
      );
      hideMessage(); // Masquer le message de chargement après la réussite
      message.success("Impression réussie!");
    } catch (error) {
      hideMessage(); // Masquer le message de chargement en cas d'erreur
      message.error("Erreur lors de l'impression.");
      console.error("Erreur lors de l'impression :", error);
    }
  };
  const handlePrintModalOk = async (docName = "ImputationsMens") => {
    const { getFieldValue } = form;
    const codeadht = getFieldValue("codeadht");
    const month = selectedMonth;
    const year = selectedYear;
    if (!codeadht && docName.includes("ImputationsMens")) {
      console.error("codeadht is undefined");
      return;
    }
    const hideMessage = message.loading("Impression en cours...", 0);
    try {
      traitementsoinsService.printImputationService(
        year,
        month,
        codeadht,
        docName
      );
      hideMessage(); // Masquer le message de chargement après la réussite
      message.success("Impression réussie!");
    } catch (error) {
      hideMessage(); // Masquer le message de chargement en cas d'erreur
      message.error("Erreur lors de l'impression.");
      console.error("Erreur lors de l'impression :", error);
    }
  };
  const handleFactureFolioPrint = async () => {
    const payload = selectedRowKeys.map(
      (key) => tableData.find((item) => item.numenreg === key).numenreg
    );
    const month = selectedMonth;
    const year = selectedYear;
    const docName = "FolioFactures";
    const hideMessage = message.loading("Impression en cours...", 0);
    try {
      await traitementsoinsService.updatedPayloadPrint(payload);
      console.log("updatedVentilationPrint successfully called");
      traitementsoinsService.printFactureFolioService(
        docName,
        year,
        month
      );
      hideMessage(); // Masquer le message de chargement après la réussite
      message.success("Impression réussie!");
    } catch (error) {
      hideMessage(); // Masquer le message de chargement en cas d'erreur
      message.error("Erreur lors de l'impression.");
      console.error("Erreur lors de l'impression :", error);
    }
  };
  const handleFactureGlobalPrint = async () => {
    const payload = selectedRowKeys.map(
      (key) => tableData.find((item) => item.numenreg === key).numenreg
    );
    const month = selectedMonth;
    const year = selectedYear;
    const docName = "FolioFactures_global";
    const hideMessage = message.loading("Impression en cours...", 0);
    try {
      await traitementsoinsService.updatedPayloadPrint(payload);
      console.log("updatedVentilationPrint successfully called");
      traitementsoinsService.printFactureGlobalService(
        docName,
        year,
        month
      );
      hideMessage(); // Masquer le message de chargement après la réussite
      message.success("Impression réussie!");
    } catch (error) {
      hideMessage(); // Masquer le message de chargement en cas d'erreur
      message.error("Erreur lors de l'impression.");
      console.error("Erreur lors de l'impression :", error);
    }
  };
  const gestionMenu = (
    <Menu>
      {(selectedOption === "C" || selectedOption === "P") && (
        <Menu.Item
          key="ImputationsMens"
          disabled={selectedRowKeys.length === 0}
          onClick={handlePrintClick}
        >
          Imputation IPM
        </Menu.Item>
      )}
      {(selectedOption === "C" || selectedOption === "P") && (
        <Menu.Item
          key="listFactures"
          disabled={selectedRowKeys.length === 0}
          onClick={handlePrintListFacture}
        >
          Liste des Factures
        </Menu.Item>
      )}
      {(selectedOption === "C" || selectedOption === "P") && (
        <Menu.Item
          key="FolioFactures"
          disabled={selectedRowKeys.length === 0}
          onClick={handleFactureFolioPrint}
        >
          Folio Facture
        </Menu.Item>
      )}
      {(selectedOption === "C" || selectedOption === "P") && (
        <Menu.Item
          key="FolioFactures_global"
          disabled={selectedRowKeys.length === 0}
          onClick={handleFactureGlobalPrint}
        >
          Folio Global
        </Menu.Item>
      )}
      {selectedOption === "T" && (
        <Menu.Item
          key="VentilationFact_IPM"
          disabled={selectedRowKeys.length === 0}
          onClick={showModalVentil}
        >
          Ventilation
        </Menu.Item>
      )}
      {selectedOption === "R" && (
        <Menu.Item
          key="Fiche_Rejet"
          disabled={selectedRowKeys.length === 0 || selectedRowKeys.length > 1}
          onClick={showModalrejet}
        >
          Rejet
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <div>
      <Modal
        open={isProgressModalVisible}
        footer={null}
        closable={false}
        centered
        maskClosable={false}
        width={350}
      >
        <div style={{ textAlign: "center", padding: 20 }}>
          <p>Traitement en cours...</p>
          <Progress percent={progress} status={progress < 100 ? "active" : "success"} />
        </div>
      </Modal>
      <Card>
        <Row
          gutter={16}
          justify="space-between"
          align="middle"
          style={{ marginBottom: "16px" }}
        >
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
            style={{
              textAlign: "right",
              display: "flex",
              justifyContent: "start",
            }}
          >
            <Space style={{ flexWrap: "nowrap" }}>
              <Space direction="vertical" style={{ textAlign: "left" }}>
                <label style={{ fontSize: 12 }}>Exercice</label>
                <Select
                  className="select-colored-accent"
                  style={{
                    marginRight: 10,
                    "--select-accent": "#1890ff",
                    "--select-accent-bg": "#e6f4ff",
                    "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                  }}
                  onChange={handleYearChange}
                  value={selectedYear}
                >
                  {years.map((year) => (
                    <Option key={year} value={year}>
                      {year}
                    </Option>
                  ))}
                </Select>
              </Space>
              <Space direction="vertical" style={{ textAlign: "left" }}>
                <label style={{ fontSize: 12 }}>Etat</label>
                <Select
                  className="select-colored-accent"
                  style={{
                    width: 140,
                    marginRight: 10,
                    "--select-accent": "#fa8c16",
                    "--select-accent-bg": "#fff7e6",
                    "--select-accent-shadow": "rgba(250, 140, 22, 0.25)",
                  }}
                  onChange={handleSelectChange}
                  value={selectedOption}
                  options={etatDescriptions}
                ></Select>
              </Space>
              {(selectedOption === "T" ||
                selectedOption === "C" ||
                selectedOption === "P") && (
                  <Space direction="vertical" style={{ textAlign: "left" }}>
                    <label>Mois</label>
                    <Select
                      className="select-colored-accent"
                      style={{
                        width: "150px",
                        "--select-accent": "#722ed1",
                        "--select-accent-bg": "#f9f0ff",
                        "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
                      }}
                      onChange={handleMonthChange}
                      value={selectedMonth}
                    >
                      {monthOptions.map((month) => (
                        <Option key={month.value} value={month.value}>
                          {month.label}
                        </Option>
                      ))}
                    </Select>
                  </Space>
                )}


              <Space direction="vertical" style={{ textAlign: "left" }}>
                <label style={{ fontSize: 12 }}>Types</label>
                <Select
                  className="select-colored-accent"
                  style={{
                    width: 100,
                    marginRight: 10,
                    "--select-accent": "#13c2c2",
                    "--select-accent-bg": "#e6fffb",
                    "--select-accent-shadow": "rgba(19, 194, 194, 0.25)",
                  }}
                  onChange={(value) => {
                    setSelectedType(value);
                    console.log("Selected Type:", value);
                  }}
                  value={selectedType}
                >
                  <Option value="Toutes">Toutes</Option>
                  <Option value="Normale">Normale</Option>
                  <Option value="RIB">RIB</Option>
                  <Option value="RIC">RIC</Option>
                  <Option value="Avoir">Avoir</Option>
                </Select>
              </Space>
            </Space>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-end",
            }}
          >
            <Space wrap>
              <Dropdown
                disabled={selectedOption === "A"}
                overlay={gestionMenu}
                trigger={["click"]}
              >
                <Button className="buttonEdition" icon={<PrinterOutlined />}>
                  Etats
                  <MoreOutlined />
                </Button>
              </Dropdown>

              <Button
                className="buttonCompta"
                icon={<CalculatorOutlined />}
                disabled={!(selectedOption === "T" && selectedRowKeys.length > 0) || loadingCompta}
                onClick={async () => {
                  setLoadingCompta(true);
                  await startProgressWithApi(handleComptabiliser());
                  setLoadingCompta(false);
                }}
              >
                {loadingCompta ? <Spin /> : "Comptabiliser"}
              </Button>

              {selectedOption === "R" && (
                <Button
                  className="buttonRecep"
                  icon={<PlusCircleOutlined />}
                  onClick={() => showModal(false)}
                >
                  Réceptionner une facture
                </Button>
              )}

              <Dropdown overlay={gestionMenu1} trigger={["click"]}>
                <Button className="Buttonvalid">
                  {/* Actions  */}
                  <MoreOutlined />
                </Button>
              </Dropdown>
            </Space>
          </Col>
        </Row>

        <Table

          rowSelection={rowSelection}
          rowKey="numenreg"
          scroll={{
            x: true,
          }}
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          className="custom-header2-table my-custom-table"
          bordered
          showSorterTooltip={false}
          loading={loading}
          dataSource={filteredData}
          columns={filterColumns}
          onChange={handleInvoiceTableChange}
          pagination={{
            pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
            showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
            pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
            onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
          }}
          // permet aussi de maintenir la couleur de la ligne
          rowClassName={(record) =>
            selectedRowKeys.includes(record.numenreg) ? "selected-row" : ""
          }
          title={() => (
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
              <span>
                Nombre de facture(s): <strong>{nombreFactures}</strong> - Total Montant :{" "}
                <strong>{formatNumberWithSeparator(totalMontant)} CFA</strong>
              </span>
              {/* <Dropdown overlay={selectionMenu} trigger={["click"]}>
                <Button style={{ marginLeft: 16, backgroundColor: "#6aab96ff" }}>
                  Sélection <DownOutlined />
                </Button>
              </Dropdown> */}
              <Input
                className="search-input-highlight"
                placeholder="Rechercher..."
                allowClear
                value={globalSearchValue}
                style={{ width: 260 }}
                onChange={(e) => handleSearch(e.target.value)}
                prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
              />
            </div>
          )}
        />
      </Card>
      <DraggableModal
        title={modalTitle}
        open={isModalVisible}
        onCancel={handleCancel}
        maskClosable={false}
        footer={null}
        style={{
          top: 20,
        }}
        width={800}
      >
        <Form
          layout="vertical"
          form={form}
          initialValues={{
            ...formValues,
            nature_fact: "Normale",
            daterecep: moment(),
          }}
          onFinish={isEditMode ? handleUpdate : handleOk}
        >
          <Row gutter={16}>
            <Divider orientation="left">
              Information Fournisseur
            </Divider>
            <Col span={12}>
              <Form.Item
                name="codespe"
                label="Spécialités"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner la Spécialité!",
                  },
                ]}
                initialValue=""
              >
                <Select
                  loading={loadingSpecialites}
                  defaultValue="--Selectionner--"
                  style={{ width: "100%" }}
                  onChange={handleFournisPrescChange}
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {specialitesData &&
                    specialitesData.map((specialite) => (
                      <Option
                        key={specialite.codespe}
                        value={specialite.codespe}
                      >
                        {`${specialite.codespe} - ${specialite.intitule}`}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="numfourn"
                label="Fournisseur"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner le fournisseur",
                  },
                ]}
                initialValue=""
              >
                <Select
                  loading={loadingFournisseur}
                  defaultValue="--Selectionner--"
                  style={{ width: "100%" }}
                  disabled={!isPrescripteurSelectEnabled}
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {prescripteursData &&
                    prescripteursData.map((prescripteur) => (
                      <Option
                        key={prescripteur.numFourn}
                        value={prescripteur.numFourn}
                      >
                        {`${prescripteur.numFourn} - ${prescripteur.raisoc}`}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Divider orientation="left">
              {" "}
              Entête Facture{" "}
            </Divider>
            <Col span={12}>
              <Form.Item
                name="numfact"
                label="N° Facture"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un N° facture!",
                  },
                ]}
                initialValue=""
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="datefact"
                label="Date Facture"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner la date de la facture!",
                  },
                ]}
                initialValue=""
              >
                <DatePicker
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                  style={{ width: "100%" }}
                  format={"DD/MM/YYYY"}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="daterecep"
                label="Reçu le"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner la date de réception!",
                  },
                ]}
              >
                <DatePicker
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                  style={{ width: "100%" }}
                  format="DD/MM/YYYY"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name="freel"
                rules={[
                  {
                    required: true,
                    message: "Veuillez entrer le montant de freel!",
                    type: "number",
                    min: 0,
                  },
                ]}
                label={`F.Réel (${formatNumberWithSeparator(
                  freelValue !== null ? freelValue : 0
                )})`}
                initialValue={0}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  onChange={(value) => setFreelValue(value)}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="remise"
                rules={[
                  {
                    required: true,
                    message: "Veuillez entrer le montant de la remise!",
                  },
                ]}
                label={`Remise (${formatNumberWithSeparator(
                  Number(remiseValue)
                )})`}
                initialValue={0}
              >
                <Input
                  value={remiseValue}
                  onChange={(e) => setRemiseValue(e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="ristourne"
                rules={[
                  {
                    required: true,
                    message: "Veuillez entrer le montant de la ristourne!",
                  },
                ]}
                label={`Ristourne (${formatNumberWithSeparator(
                  Number(ristourneValue)
                )})`}
                initialValue={0}
              >
                <Input
                  value={ristourneValue}
                  onChange={(e) => setRistourneValue(e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="qp_agent"
                rules={[
                  {
                    required: true,
                    message: "Veuillez entrer le montant de QP.Agent!",
                    type: "number",
                    min: 0,
                  },
                ]}
                label={`QP.Agent (${formatNumberWithSeparator(
                  agentValue !== null ? agentValue : 0
                )})`}
                initialValue={0}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  value={agentValue}
                  onChange={(value) => setAgentValue(value)}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            name="montfact"
            style={{ marginTop: "-25px", marginBottom: "-25px" }}
          >
            <div style={{ textAlign: "right", color: "#010f1c" }}>
              <strong>
                <h3>
                  Montant Net Facture:{" "}
                  {formatNumberWithSeparator(montantNetAffiche)}
                </h3>
              </strong>
            </div>
          </Form.Item>

          <Divider orientation="left">
            Type de Facture
          </Divider>

          <Space style={{ display: "flex", justifyContent: "space-between" }}>
            <Form.Item>
              <Checkbox
                value="Prepaid"
                checked={checkedValue === "Prepaid"}
                onChange={handleCheckboxChange}
              >
                Facture Prépayée{" "}
                {confirmedMontantPrepaye > 0 &&
                  `(${formatNumberWithSeparator(confirmedMontantPrepaye)})`}
              </Checkbox>
            </Form.Item>
            <Form.Item>
              <Checkbox
                value="rembourse"
                checked={checkedValue === "rembourse"}
                onChange={handleCheckboxChange}
              >
                Remboursement Ticket
              </Checkbox>
            </Form.Item>
            <Form.Item>
              <Checkbox
                value="Avoir"
                checked={checkedValue === "Avoir"}
                onChange={handleCheckboxChange}
              >
                Facture d'avoir
              </Checkbox>
            </Form.Item>
            <Form.Item>
              <Checkbox
                value="Normale"
                checked={checkedValue === "Normale"}
                onChange={handleCheckboxChange}
              >
                Normale
              </Checkbox>
            </Form.Item>
          </Space>

          {checkedValue === "rembourse" && (
            <Form.Item name="typeremb" initialValue="compense">
              <Radio.Group style={{ paddingLeft: 210 }}>
                <Radio.Button value="compense">Compense</Radio.Button>
                <Radio.Button value="banque">Comptant</Radio.Button>
              </Radio.Group>
            </Form.Item>
          )}

          <DraggableModal
            title="Facture Prépayé"
            open={isModalVisible1}
            onOk={handleConfirm}
            onCancel={handleCancel1}
            footer={[
              <Button key="back" onClick={handleCancel1}>
                Annuler
              </Button>,
              <Button key="submit" type="primary" onClick={handleConfirm}>
                Confirmer
              </Button>,
            ]}
          >
            <Form.Item name="mont_prepaid" label="Montant Prépayé">
              <InputNumber
                min={0}
                value={montantPrepaye}
                onChange={setMontantPrepaye}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </DraggableModal>
          <div style={{ marginTop: "20px", textAlign: "right" }}>
            <Form.Item>
              <Button onClick={handleCancel} type="dashed" danger>
                Fermer
              </Button>
              <Button
                htmlType="submit"
                type="primary"
                style={{ backgroundColor: "#010f1c", marginLeft: 8 }}
              >
                Enregister
              </Button>
            </Form.Item>
          </div>
        </Form>
      </DraggableModal>
      <DraggableModal
        title="Chargement Facture"
        open={isFileModalVisible}
        onCancel={hideFileModal}
        footer={null}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "40px",
          }}
        >
          <Button
            onClick={handleImportFile}
            type="primary"
            style={{ backgroundColor: "#010f1c", width: "40%" }}
            loading={isFileUploading}
          >
            Import Facture
          </Button>
        </div>
        <div style={{ marginTop: "20px", textAlign: "right" }}>
          <Button
            type="dashed"
            danger
            onClick={hideFileModal}
            style={{ marginRight: 8 }}
          >
            Annuler
          </Button>
        </div>
      </DraggableModal>
      <DraggableModal
        title="Imputation Ipm"
        open={isPrintModalVisible}
        onOk={() => handlePrintModalOk()}
        onCancel={handlePrintModalCancel}
        width={800}
        style={{ top: 20 }}
        maskClosable={false}
        footer={[
          <Button key="back" className="buttonClose" onClick={handlePrintModalCancel}>
            Fermer
          </Button>,

          <Button
            key="excel"
            className="buttonExport"
            onClick={handleExportToExcel}
          >
            Détails Imputations
          </Button>,
          <Dropdown
            key="excel-etats"
            overlay={
              <Menu>
                <Menu.Item key="single-sheet" onClick={handleExportSingleSheet}>
                  Feuille Unique
                </Menu.Item>
                <Menu.Item key="by-societe" onClick={handleExportBySociete}>
                  Feuille Par Société
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
          >
            <Button className="buttonExport">
              Etats Excel <DownOutlined />
            </Button>
          </Dropdown>,
          <Dropdown
            key="submit"
            overlay={
              <Menu>
                <Menu.Item key="details" onClick={() => handlePrintModalOk("ImputationsMens")}>
                  Détails
                </Menu.Item>
                <Menu.Item key="recap_societe" onClick={() => handlePrintModalOk("ImputationsMensRecap")}>
                  Récap / Societé
                </Menu.Item>
                <Menu.Item key="recap_participant" onClick={() => handlePrintModalOk("ImputationsMensRecapPart")}>
                  Récap / Participant
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
          >
            <Button className="buttonImprim">
              Etats PDF <DownOutlined />
            </Button>
          </Dropdown>,
        ]}
      >
        <Form form={form} layout="vertical">
          <Form.Item>
            <Select
              bordered={false}
              style={{ marginRight: 10, borderBottom: "2px solid #030303" }}
              onChange={handleYearChangeExercises}
              value={selectedYear}
            >
              {years.map((year) => (
                <Option key={year} value={year}>
                  {year}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <Select
              bordered={false}
              style={{ borderBottom: "2px solid #030303" }}
              onChange={setSelectedMonth}
              value={selectedMonth}
            >
              {monthOptions.map((month) => (
                <Option key={month.value} value={month.value}>
                  {month.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="codeadht"
            label="Société"
            initialValue={selecteAdherent}
          >
            <Select
              bordered={false}
              style={{ borderBottom: "1px solid black" }}
              onChange={onchangeAdherent}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              <Select.Option value="AA">Toutes les sociétés</Select.Option>
              {adherentsData.map((adherent) => (
                <Option key={adherent.codeadht} value={adherent.codeadht}>
                  {`${adherent.codeadht} - ${adherent.intitule}`}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </DraggableModal>
      <DraggableModal
        title="Motif Rejet"
        open={isModalRejet}
        onOk={handlePrintRejet}
        onCancel={handleCancelRejet}
        footer={[
          <Button key="back" onClick={handleCancelRejet}>
            Annuler
          </Button>,
          <Button
            key="submit"
            className="buttonImprim"
            onClick={handlePrintRejet}
          >
            Imprimer
          </Button>,
        ]}
      >
        <Form layout="vertical" form={form}>
          <Form.Item name="motif_rejet" label="Motif Rejet">
            <Input />
          </Form.Item>
        </Form>
      </DraggableModal>
      <DraggableModal
        title="Ventilation"
        open={isModalVentil}
        onCancel={handleCancelVentil}
        footer={[
          <Button key="back" onClick={handleCancelVentil}>
            Annuler
          </Button>,
        ]}
      >
        <Space
          style={{ display: "flex", justifyContent: "center", padding: "10px" }}
        >
          <Button
            key="submit"
            className="buttonImprim"
            onClick={handlePrintVentil}
          >
            Imprimer
          </Button>
          <Button className="buttonPreview" onClick={handlePreview}>
            Preview
          </Button>
        </Space>
      </DraggableModal>
      <PreviewModal
        visible={isPreviewModalVisible}
        onCancel={handleCancelPreview}
        data={previewData}
      />
      <DraggableModal
        title={`Aperçu écritures au journal - Facture N° ${selectedFact?.numfact} - Fournisseur: ${selectedFact?.numfourn}`}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        maskClosable={false}
        footer={[
          <Button
            className="buttonExport"
            onClick={() =>
              exportToExcel(
                prepareDataForExport(comptaPreviewData),
                "AperçuEcritureJournalExport.xlsx"
              )
            }
          >
            Export
          </Button>,
          <Button
            key="back"
            className="buttonClose"
            onClick={() => setIsModalOpen(false)}
          >
            Fermer
          </Button>,
          <Button
            className="Buttonvalid"
            disabled={solde1 !== 0 || loadingValid}
            onClick={handleValidCompta}
          >
            {loadingValid ? <Spin size="small" /> : "Valider"}
          </Button>,
        ]}
        width={1200}
        style={{ top: 20 }}
      >
        <Input
          placeholder="Recherche..."
          bordered={false}
          style={{
            borderBottom: "2px solid #030303",
            width: "20%",
            marginBottom: 30,
          }}
        />
        <Table
          scroll={{
            x: true,
          }}
          className="custom-header1-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          bordered
          showSorterTooltip={false}
          dataSource={comptaPreviewData}
          columns={columns1}
          footer={() => (
            <div style={{ textAlign: "right" }}>
              <Space>
                <strong>Total Débit : {formatNumber(totalDebit1)}</strong>
                <strong>Total Crédit : {formatNumber(totalCredit1)}</strong>
                <strong> Solde : {formatNumber(solde1)}</strong>
              </Space>
            </div>
          )}
        />
      </DraggableModal>
      <DraggableModal
        title="Annulation Comptabilisation"
        open={isAnnulationModalOpen}
        onCancel={() => setIsAnnulationModalOpen(false)}
        maskClosable={false}
        footer={[
          <Button
            key="back"
            className="buttonClose"
            onClick={() => setIsAnnulationModalOpen(false)}
          >
            Fermer
          </Button>,
          <Button
            className="Buttonvalid"
            disabled={solde !== 0}
            onClick={handleValidAnnulationCompta}
          >
            Valider
          </Button>,
        ]}
        width={1500}
        style={{ top: 20 }}
      >
        <Input
          placeholder="Recherche..."
          bordered={false}
          style={{
            borderBottom: "2px solid #030303",
            width: "20%",
            marginBottom: 30,
          }}
        />
        <Table
          pagination={{ pageSize: 5 }}
          className="custom-header1-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          bordered
          scroll={{
            x: true,
          }}
          dataSource={annulationPreviewData}
          columns={columns1}
          footer={() => (
            <div style={{ textAlign: "right" }}>
              <Space>
                <strong>Total Débit : {formatNumber(totalDebit)}</strong>

                <strong>Total Crédit : {formatNumber(totalCredit)}</strong>

                <strong> Solde : {formatNumber(solde)}</strong>
              </Space>
            </div>
          )}
        />
      </DraggableModal>

      <Modal
        title="Modifier Mois Compta"
        open={isModalOpenCompta}
        onCancel={handleCancelcompta}
        footer={[
          <Button key="cancel" onClick={handleCancelcompta}>
            Annuler
          </Button>,
          <Button key="submit" type="primary" onClick={handlecomptaOk}>
            Valider
          </Button>,
        ]}
      >
        <Form layout="vertical">
          <Form.Item label="Sélectionnez un mois">
            <DatePicker
              picker="month"
              format="MMM-YYYY"
              value={selectedMonthCompta}
              onChange={handleMonthcomptaChange}
              disabledDate={(current) => current && current > dayjs().endOf('day')}
            />
          </Form.Item>
        </Form>
      </Modal>

    </div>
  );
};
export default TraiteFournSoins;
